import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { Paper } from '../Paper';
import { omit } from '../helpers';
import { BalloonArrow } from './BalloonArrow';
var StyledBalloonContent = styled(Paper)(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      level = _ref.level;
  return theme.zIndex[level];
});
var normalizeProps = omit(['onOutsideClick']);
export function BalloonContent(_a) {
  var popperProps = _a.popperProps,
      placement = _a.placement,
      content = _a.content,
      _a$showArrow = _a.showArrow,
      showArrow = _a$showArrow === void 0 ? true : _a$showArrow,
      _a$level = _a.level,
      level = _a$level === void 0 ? 'popup' : _a$level,
      props = __rest(_a, ["popperProps", "placement", "content", "showArrow", "level"]);

  if (popperProps.outOfBoundaries) {
    return null;
  }

  var arrow = level === 'tooltip' ? false : showArrow;
  return React.createElement(StyledBalloonContent, Object.assign({
    level: level,
    ref: popperProps.ref,
    style: popperProps.style,
    "data-placement": popperProps.placement
  }, normalizeProps(props)), arrow && React.createElement(BalloonArrow, Object.assign({}, popperProps.arrowProps, {
    placement: placement
  })), content);
}